<template>
    <div class="home-content">
      <!-- 商机 --> 
      <div class="home-t">
        <div class="home-l" v-if="type === '0'">
          <div class="home-l-title">
            <span>CMEF headline</span>
          </div>
          <div v-if="hotNewList.length" style="padding:0 20px;">
            <div class="new-list" v-for="(item,index) in hotNewList" :key="index" @click="linkToNews(item)">
              <div class="new-list-l">
                <img :src="item.coverUrl" v-if="item.coverUrl"> 
                <img src="@/assets/img/empty.png" v-else>
              </div>
              <div class="new-list-r">
                <h2>{{item.title}}</h2>
                <p>{{item.summary}}</p>
                <span>{{$service.SmarDateEn(new Date(item.pubTime))}}</span>
              </div>
            </div>
            <div class="load-more" v-if="hotNewList.length >= ToTal ">
              No more
            </div>
            <div class="load-more" @click="loadMore" v-else>
              Load more 
            </div>
          </div>
          <div class="no-msg" v-else>
           No Data！
          </div>
        </div>
        <div class="home-l" v-else>
          <div class="home-l-title">
            <span>CMEF headline</span>
          </div>
          <div v-if="hotNewList.length" style="padding:0 20px;">
            <div class="new-list" v-for="(item,index) in hotNewList" :key="index" @click="$router.push('/news-detailsEn?id=' + item.id);">
              <div class="new-list-l">
                <img :src="item.coverUrl" v-if="item.coverUrl"> 
                <img src="@/assets/img/empty.png" v-else>
              </div>
              <div class="new-list-r">
                <h2>{{item.title}}</h2>
                <p>{{item.summary}}</p>
                <span>{{$service.SmarDateEn(new Date(item.inTime))}}</span>
              </div>
            </div>
            <div class="load-more" v-if="hotNewList.length >= ToTal2 ">
              No more
            </div>
            <div class="load-more" @click="loadMore" v-else>
              Load more 
            </div>
          </div>
          <div class="no-msg" v-else>
           No Data！
          </div>
        </div>
        <div class="home-r">
          <newsList :hotNewList="hotNewList"></newsList>
        </div>
      </div>
    </div>
</template>

<script>
import newsList from "./news-list";
import { mapActions, mapGetters } from "vuex";


export default {
  name: "news",
  data() {
    return {
      hotNewList:[],
      ToTal:0,
      PageIndex:1,
      PageSize:10,

      ToTal2:0,
      PageIndex2:1,
      PageSize2:10,
    };
  },
  components: {
    newsList,
  },
  watch: {
    type(val, oldVal) {
      if (val === "0") {
        this.hotNewList = [];
        this.pageSize = 10;
        this.PageIndex = 1;
        this.ToTal = 0;
        this.getData1();
      } else {
        this.hotNewList = [];
        this.PageSize2 = 10;
        this.PageIndex2 = 1;
        this.ToTal2 = 0;
      this.getData2();
    }
    }
  },
  computed: { 
    ...mapGetters({
    }),
    type() {
      return this.$route.query.type;
    }
  },
  async created() {
    if (this.type === "0") {
      this.getData1();
    } else {
      this.getData2();
    }
  },
  mounted(){
  },
  methods: {
    ...mapActions({  
      getHostNews: "getHostNews",
      getExNews: "getExNews"
    }),
    async getData1() { 
      let list = await this.getHostNews(
        {
          "pageSize": this.PageSize,
          "pageIndex": this.PageIndex,
        }
      );
      this.hotNewList = list.items;
      this.PageSize = list.pageSize;
      this.PageIndex = list.pageIndex;
      this.ToTal = list.totalCount;
    },
    async getData2() { 
      let list = await this.getExNews(
        {
          "pageSize": this.PageSize2,
          "pageIndex": this.PageIndex2,
        }
      );
      this.hotNewList = list.items;
      this.PageSize2 = list.pageSize;
      this.PageIndex2 = list.pageIndex;
      this.ToTal2 = list.totalCount;
    },
    loadMore(){
      if (this.type === "0") {
        this.PageIndex = 1;
        this.PageSize = 500;
        this.getData1();
      } else {
        this.PageIndex2 = 1;
        this.PageSize2 = 500;
        this.getData2();
      }
    },
    linkToNews(item){
      if (item.link) {
        window.open(item.link,'_blank');
      } else {
        this.$router.push('/news-detailsEn?id=' + item.id + "&genre=host");
      }
    }
  },
};
</script>

<style scoped lang='scss'>
.home-content{
    margin-top: 20px;
    width: 1200px;
    margin: 0 auto 60px;
    .home-t{
        // display: flex;
        &::after {
          content: "";
          clear: left;
          display: block;
        }
    }
    .home-l{
        margin-right: 20px;
        width: 880px;
        background: #fff;
        float: left;
        &-title {
          width: 100%;
          height: 40px;
          border-bottom: 2px solid #024c8b;
          span {
            display: inline-block;
            width: 150px;
            height: 40px;
            background-color: #024c8b;
            text-align: center;
            line-height: 40px;
            color: #fff;
            font-size: 18px;
          }
        }
        .new-list{
          padding:25px 0 ;
          border-bottom: 1px solid #f2eded;
          display: flex;
          align-items: center;
          cursor: pointer;
          &-l{
            width: 185px;
            height: 120px;
            background-color: #dcdcdc;
            border-radius: 5px;
            margin-right: 20px;
            img{
              width: 100%;
              height: 100%;
              border-radius: 5px;
            }
          }
          &-r{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 120px;
            width: 630px;
            h2{
              font-size: 20px;
              font-weight: bold;
              line-height: 30px;
              color: #333;
            }
            p{
              font-size: 14px;
              line-height: 24px;
              color: #333;
              position: relative;
              top:-6px;
            }
            h2,p{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span{
              font-size: 12px;
              line-height: 24px;
              color: #666;
            }
          }
        }
        .new-list:last-child{
          border-bottom: none;
        }
        .new-list:hover{
          h2{
            color: #024c8b;
          }
        }
    }
    .home-r{
        float: left;
        width: 300px;
    }
}
.no-msg{
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 100px;
}
.load-more{
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #666;
  padding:20px 0;
  cursor: pointer;
}
</style>